import { ActionContext } from 'vuex';
import events from '../../data/events';
import { Evnt } from '../../__types';

type State = {
  allEvents?: Evnt[];
  currentEvent?: null | Evnt;
  minimized?: boolean;
};

const state: State = {
  allEvents: events,
  currentEvent: null,
};

const getters = {
  getAllEvents: (state: State) => state.allEvents,
  getCurrentEvent: (state: State) => state.currentEvent,
  getEventById: (state: State) => (id: string) =>
    state.allEvents?.find((evnt: Evnt) => evnt.id === id),
  getEventsByDate: (state: State) => (date: Date) =>
    state.allEvents?.filter(
      (evnt: Evnt) => evnt.date.valueOf() === date.valueOf(),
    ),
};

const actions = {
  setCurrentEventById(
    { commit, getters }: ActionContext<State, State>,
    id: string,
  ) {
    const evnt = getters.getEventById(id);

    commit('newCurrentEvent', evnt);
  },
};

const mutations = {
  newCurrentEvent: (state: State, evnt: Evnt) => (state.currentEvent = evnt),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
